import { render, staticRenderFns } from "./SidePage.vue?vue&type=template&id=da381286&scoped=true&"
import script from "./SidePage.vue?vue&type=script&lang=js&"
export * from "./SidePage.vue?vue&type=script&lang=js&"
import style0 from "./SidePage.vue?vue&type=style&index=0&id=da381286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da381286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da381286')) {
      api.createRecord('da381286', component.options)
    } else {
      api.reload('da381286', component.options)
    }
    module.hot.accept("./SidePage.vue?vue&type=template&id=da381286&scoped=true&", function () {
      api.rerender('da381286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/SidePage.vue"
export default component.exports